import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../client/client";
import { useLogin } from "../context/LoginContext";
import Layout from "./Layout";
import Loading from "./Loading";

const CategoryPage = () => {
  const [loading, setLoading] = useState(true);
  const [processArea, setProcessArea] = useState([]);
  const [userData, setUserData] = useState(null);
  const { getSessionAuth } = useLogin();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionAuth = async () => {
      const session = await getSessionAuth();
      if (session) {
        await getUser(session.id);
        setLoading(false);
      } else {
        navigate("/", { replace: true });
      }
    };
    sessionAuth();
  }, []);

  useEffect(() => {
    if (userData !== null)
      getAreas();
  }, [userData])

  const getUser = async (id) => {
    const { error, data } = await supabase
      .from("users")
      .select()
      .eq(`id`, id)
      .single();
    if (error) throw error.message;
    setUserData(data);
  };

  const getAreas = async () => {
    try {
      if (userData.role !== undefined) {
        if (userData.role === "admin") {
          const { data, error } = await supabase
            .from("areas")
            .select(`name`)
            .eq('name',"ARBITRAJE");
          if (error) throw error;
          const areas = data.map((item) => {
            return { name: item.name };
          }
          );
          setProcessArea(areas);
        } else {
          const { data, error } = await supabase
            .from("area_users")
            .select(`areas(name)`)
            .eq("id_user", userData.id);
          if (error) throw error;
          const areas = data.map((item) => {
            return { name: item.areas.name };
          });
          setProcessArea(areas);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Layout>
      {loading && <Loading />}
      <div className="mb-8">
        <h1 className="text-[#4691A6] font-bold text-3xl">ÁREA</h1>
        <p className="text-gray-500 text-sm mt-1">Selecciona un área para ver sus equipos.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {processArea.map((areaName, index) => (
          <Link
            key={index}
            to={`/producto/${areaName.name}`}
            className="group flex flex-col items-center justify-center gap-2 bg-white border border-gray-200 rounded-xl p-6 text-center hover:border-[#4691A6] hover:shadow-md transition-all duration-200"
          >
            <div className="w-10 h-10 rounded-full bg-[#356674]/10 flex items-center justify-center group-hover:bg-[#4691A6]/10 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-[#356674] group-hover:text-[#4691A6]">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3" />
              </svg>
            </div>
            <p className="font-semibold text-gray-800 text-sm">{areaName.name}</p>
          </Link>
        ))}
      </div>
    </Layout>
  );
};

export default CategoryPage;
